import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path stroke=\"currentColor\" d=\"M1.067 4.267h6.4\"></path><circle cx=\"9.6\" cy=\"4.267\" r=\"2.133\" stroke=\"currentColor\" transform=\"rotate(90 9.6 4.267)\"></circle><path stroke=\"currentColor\" d=\"M11.733 4.267h3.2M3.2 11.533H1.067\"></path><circle cx=\"2.133\" cy=\"2.133\" r=\"2.133\" stroke=\"currentColor\" transform=\"matrix(0 1 1 0 3.2 9.4)\"></circle><path stroke=\"currentColor\" d=\"M14.933 11.533H7.467\"></path>", 5)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "filter"}) } }